module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mt-header', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "width": "100%",
      "z-index": "1000"
    },
    attrs: {
      "title": "实名认证"
    }
  }, [_c('div', {
    attrs: {
      "slot": "left"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/certification')
      }
    },
    slot: "left"
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "wish"
  }, [_vm._v("恭喜，您已经通过实名认证！")]), _vm._v(" "), _c('div', {
    staticClass: "userinfo"
  }, [_c('div', [_vm._v("认证身份："), _c('span', [_vm._v(_vm._s(_vm.identity))])]), _vm._v(" "), _c('div', [_vm._v("真实姓名："), _c('span', [_vm._v(_vm._s(_vm.realName))])]), _vm._v(" "), _c('div', [_vm._v("身份证号码："), _c('span', [_vm._v(_vm._s(_vm.IDnumber))])]), _vm._v(" "), _c('div', [_vm._v("证件有效期："), _c('span', [_vm._v(_vm._s(_vm.effective))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-106aaf5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/realName/realNameSuccess.vue
// module id = 1260
// module chunks = 1